document.addEventListener('DOMContentLoaded', function() {
  function initializeValidation() {
    const broderieInputs = document.querySelectorAll('[data-broderie="text"]');
    const submitButton = document.querySelector('button[name="add"]');
    const form = document.querySelector('product-embroidery-form form');

    let globalHasInvalidChars = false;
    let timeout;

    function checkSpecialCharacters() {
      let hasInvalidChars = false;
      broderieInputs.forEach(input => {
        const value = input.value;
        const allowedPattern = /^[a-zA-ZÀ-ÿ0-9\s.']*$/;
        if (!allowedPattern.test(value) && value !== '') {
          hasInvalidChars = true;
          // Délai avant d'afficher le message sur mobile
          clearTimeout(timeout);
          timeout = setTimeout(() => {
            showError(input);
          }, 300); // 300ms de délai
        } else {
          const errorDiv = input.parentElement.querySelector('.broderie-error');
          if (errorDiv) {
            errorDiv.remove();
          }
        }
      });
      globalHasInvalidChars = hasInvalidChars;
      return hasInvalidChars;
    }

    function showError(input) {
      let errorDiv = input.parentElement.querySelector('.broderie-error');
      if (!errorDiv) {
        errorDiv = document.createElement('div');
        errorDiv.className = 'broderie-error text-red-500 text-sm mt-2';
        input.parentElement.appendChild(errorDiv);
      }
      errorDiv.textContent = 'Les caractères spéciaux ne sont pas autorisés.';
    }

    function updateButtonState() {
      if (submitButton) {
        submitButton.disabled = globalHasInvalidChars;
        if (globalHasInvalidChars) {
          submitButton.classList.add('opacity-50', 'cursor-not-allowed');
        } else {
          submitButton.classList.remove('opacity-50', 'cursor-not-allowed');
        }
      }
    }

    // Event listeners
    broderieInputs.forEach(input => {
      input.addEventListener('input', () => {
        checkSpecialCharacters();
        updateButtonState();
      }, { passive: true }); // Optimisation pour mobile
    });

    if (form) {
      form.addEventListener('change', () => {
        updateButtonState();
      }, { passive: true });
    }

    document.addEventListener('click', () => {
      updateButtonState();
    }, { passive: true });

    // Initial check
    checkSpecialCharacters();
    updateButtonState();
  }

  // Observer for dynamic fields
  const observer = new MutationObserver(() => {
    initializeValidation();
  });

  const container = document.querySelector('product-embroidery');
  if (container) {
    observer.observe(container, {
      childList: true,
      subtree: true
    });
  }

  initializeValidation();
});